import { render, staticRenderFns } from "./TodoAddNew.vue?vue&type=template&id=ff1128aa&"
import script from "./TodoAddNew.vue?vue&type=script&lang=js&"
export * from "./TodoAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1128aa')) {
      api.createRecord('ff1128aa', component.options)
    } else {
      api.reload('ff1128aa', component.options)
    }
    module.hot.accept("./TodoAddNew.vue?vue&type=template&id=ff1128aa&", function () {
      api.rerender('ff1128aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/todo/TodoAddNew.vue"
export default component.exports